/**
 * @generated SignedSource<<cdc65ef3a6fe96ca7550d218bc3b5630>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DurationFilterControlFragment_facility$data = {
  readonly durations: ReadonlyArray<number | null | undefined> | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "DurationFilterControlFragment_facility";
};
export type DurationFilterControlFragment_facility$key = {
  readonly " $data"?: DurationFilterControlFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"DurationFilterControlFragment_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DurationFilterControlFragment_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durations",
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "d7411a04523c503a670429590099e989";

export default node;
